import React from "react";
import { FormGroup, Label } from "reactstrap";
import styles from "./Field.module.scss";
import Symbol from "./Symbol/Symbol";
import Account from "./Account/Account";
import Numeric from "./Numeric";
import Combobox from "./Combobox";
import Switch from "./Switch";
import TimeForce from "./TimeForce";
import PriceType from "./PriceType";
import FormSelector from "./FormSelector";
import Side from "./Side";

export const Field = ({ children, label, error, description, style = {}, noLabel }) => (
  <FormGroup className={styles.field} style={style}>
    {!noLabel && <Label>{label}</Label>}
    {children}
    <div className="invalid-feedback" style={{ display: error ? "block" : "none" }}>
      {error}
    </div>
    {!error && description && (
      <div className="valid-feedback" style={{ display: "block", color: "gray" }}>
        {description}
      </div>
    )}
  </FormGroup>
);

export { Symbol, Account, Numeric, Combobox, Switch, TimeForce, PriceType, FormSelector, Side };
